import React, { useContext, useEffect } from "react";
import SetCard from "components/ui/SetCard";
import { Grid } from "@mui/material";
import { transformSetData } from "utils/transformdata";
import { useGlobalContext } from "context/GlobalContext";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { getPartialSetsData, getSetsData, usePurchasesSets } from "../Sets/Api/api";
import SortContext from "context/SortContext";
import SetSkeleton from "components/ui/Skeleton/SetSkeleton";
import { useInView } from "react-intersection-observer";

function SetsPurchase({ isPartial }) {

  const { clientId } = useParams();
  // const { sets, total } = isPartial ? getPartialSetsData() : getSetsData();
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = usePurchasesSets({
    clientCode: clientId,
    limit: 15,
    searchTerm: "",
    isPartial
  });

  const sets = data?.pages?.flatMap(page => page.sets) || [];
  const total = data?.pages?.[0]?.total || 0;

  
  const navigate = useNavigate();

  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();
  const { setSortOptions } = useContext(SortContext);

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 1.0,
  });

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(total);
      // setFilterChangeDesignCount(total);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }

    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [sets, total]);

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  const handleSetClick = (setId, setNumber) => {
    navigate(`SET - ${setNumber}?setId=${setId}`);
  };

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

  if (isLoading) return <SetSkeleton count={12} />;
  if (isError) return <div style={{ color: "red" }}>Error: {error.message}</div>;

  return (
    <>
    <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px",  maxHeight: "85vh",  overflow: "auto", scrollbarWidth: "none" }}
      >
        {sets.map((set) => {
        return (
            <Grid item className="product" key={set._id} onClick={() => handleSetClick(set?._id, set?.setNumber)}>
              <SetCard
              isBtn={false}
              openDrawer={() => console.log("open drawer")}
              buttonClick={() => alert("Button Click")}
              innerChnages={false}
              data={transformSetData(set)}
              isPresent={false}
              isPartial={isPartial}
            />
            </Grid>
          );
        })}
        <div ref={ref} style={{ height: "20px", marginTop: "10px" }} />
      </Grid>

      {isFetchingNextPage && <SetSkeleton count={12} />}
    </>
  );
}

export default SetsPurchase;
